const INITIAL_STATE = { list: [], selectedEquipe: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'EQUIPE_FETCHED':
      return { ...state, list: action.payload.data };
    case 'EQUIPE_PAGE':
      return { ...state, paginaAtual: action.payload };
    case 'EQUIPE_SELECTED':
      return { ...state, selectedEquipe: action.payload };
    default:
      return state;
  }
};
